(() => {
  // app/scripts/predictive-search-custom.js
  var { serializeForm, debounceTime } = theme;
  var PredictiveSearchCustom = class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("form");
      this.input = this.querySelector("[name=q]");
      this.serializeForm = serializeForm;
      this.input.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === "Return") {
          event.preventDefault();
        }
      });
      this.addEventListener("input", debounceTime((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener("click", this.onFocus.bind(this));
      this.input.addEventListener("touchstart", this.onFocus.bind(this), { passive: true });
      this.addEventListener("focusout", this.onFocusOut.bind(this));
      this.addEventListener("keyup", this.onKeyup.bind(this));
    }
    onChange(e) {
      const key = e.target.value.trim();
      if (!key.length) {
        this.close();
        return;
      }
      this.getRequest(key);
    }
    getRequest(key, recommend) {
      this.searchQuery = JSON.parse(this.serializeForm(this.form));
      this.searchQuery.q = key;
      this.searchQuery.section_id = this.dataset.section;
      this.classList.add("is-searching");
      const query = new URLSearchParams(this.searchQuery).toString();
      const url = this.dataset.url + "?" + query;
      const _url = url.replace("?", "?resources[options][fields]=title,tag&");
      const newUrl = _url.replace("type=", "resources[type]=");
      fetch(newUrl).then((e) => e.text()).then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        const content = div.querySelector(".content-body .content-body-wrapper .content-body__articles");
        const contentCurrent = document.querySelector(".content-body .content-body-wrapper");
        contentCurrent.innerHTML = "";
        contentCurrent.appendChild(content);
        const showing = div.querySelector(".content-body .blogs-showing");
        const showingCurrent = document.querySelector(".blogs-showing");
        showingCurrent.parentNode.replaceChild(showing, showingCurrent);
      }).finally(() => {
        this.classList.remove("is-searching");
        this.open();
      });
    }
    focusSearch() {
      this.input.focus();
    }
    open() {
      this.classList.add("show");
    }
    close() {
      this.classList.remove("show");
    }
    onFocus() {
      this.open();
    }
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement))
          this.close();
      });
    }
    onKeyup(event) {
      if (event.code == "Escape")
        this.close();
    }
  };
  customElements.define("predictive-search-custom", PredictiveSearchCustom);
})();
